// extracted by mini-css-extract-plugin
export var section = "index-module--section--1PsEm";
export var sectionBackground = "index-module--sectionBackground--1vW6e";
export var title = "index-module--title--38bck";
export var description = "index-module--description--hBc36";
export var callToAction = "index-module--callToAction--3JN8u";
export var loadingSpinner = "index-module--loadingSpinner--1H6o9";
export var spin = "index-module--spin--NxQ7x";